var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRocketship = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 517,
    viewBox: "0 0 329 517",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.0814 288.858C93.0694 291.416 112.762 288.874 102.317 270.477C101.267 268.64 101.405 266.386 101.192 264.279C100.065 253.137 91.5947 254.617 83.8932 249.932C81.5941 248.538 79.9991 243.47 78.1062 241.563C65.1134 228.435 42.0786 233.078 35.2129 250.234C22.4203 238.375 2.13377 254.391 10.6975 269.585C5.66575 268.732 0.515519 273.546 1.03647 278.62C2.81309 295.668 63.6873 286.997 76.0814 288.858Z",
    fill: "#F6F6F1",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.082 288.862C63.6879 287.001 9.13209 296.674 7.35547 279.627C9.65021 271.062 12.6487 276.869 15.0603 274.621C19.7727 270.227 14.7195 265.338 24.4031 260.862C30.7355 257.936 62.7379 269.293 75.116 269.502C83.5624 269.644 91.8717 252.084 102.317 270.481C112.763 288.877 93.0701 291.42 76.082 288.862Z",
    fill: "#FA7B6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0814 288.858C93.0694 291.416 112.762 288.874 102.317 270.477C101.267 268.64 101.405 266.386 101.192 264.279C100.065 253.137 91.5947 254.617 83.8932 249.932C81.5941 248.538 79.9991 243.47 78.1062 241.563C65.1134 228.435 42.0786 233.078 35.2129 250.234C22.4203 238.375 2.13377 254.391 10.6975 269.585C5.66575 268.732 0.515519 273.546 1.03647 278.62C2.81309 295.668 63.6873 286.997 76.0814 288.858Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M278.571 26.1067C292.718 26.0975 306.863 26.0929 321.014 26.0846C328.693 26.0808 330.096 18.9547 323.375 17.7676C326.586 9.13385 316.215 8.64451 312.412 6.63054C309.815 5.25163 307.92 2.72406 305.204 1.61029C302.395 0.456253 299.094 1.03642 296.45 2.53372C293.807 4.03102 291.729 6.34807 289.895 8.77014C281.028 4.74915 273.665 23.9968 278.571 26.1067Z",
    fill: "#F6F6F1",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M321.013 26.0847C306.862 26.093 292.717 26.0976 278.57 26.1067C279.858 18.816 290.007 23.1675 289.765 19.2127C289.226 10.3836 307.214 14.4061 309.483 11.4918C315.51 3.75322 320.229 20.0555 322.926 20.302C325.164 20.5065 325.06 23.7776 324.728 25.3877C323.73 25.8208 322.487 26.0839 321.013 26.0847Z",
    fill: "#FA7B6A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M278.571 26.1067C292.718 26.0975 306.863 26.0929 321.014 26.0846C328.693 26.0808 330.096 18.9547 323.375 17.7676C326.586 9.13385 316.215 8.64451 312.412 6.63054C309.815 5.25163 307.92 2.72406 305.204 1.61029C302.395 0.456253 299.094 1.03642 296.45 2.53372C293.807 4.03102 291.729 6.34807 289.895 8.77014C281.028 4.74915 273.665 23.9968 278.571 26.1067Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.686 335.07L137.045 326.902C138.744 326.395 140.452 327.667 140.452 329.44V429.025C140.452 429.946 139.974 430.8 139.19 431.282L119.211 443.558C118.728 443.855 118.354 444.298 118.141 444.823L92.3939 508.574C91.9895 509.575 91.0178 510.231 89.938 510.231H35.6516C33.7391 510.231 32.457 508.266 33.2273 506.516L108.02 336.541C108.333 335.83 108.942 335.292 109.686 335.07Z",
    fill: "#F6F6F1",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.83 343.233L139.143 337.589C139.81 337.428 140.452 337.933 140.452 338.619V347.945C140.452 348.378 140.183 348.768 139.783 348.935C118.308 357.889 110.393 377.051 101.809 398.277C101.477 399.099 100.343 399.173 99.9057 398.402L96.7306 392.799C96.5745 392.524 96.5498 392.193 96.6633 391.897L115.09 343.883C115.215 343.558 115.492 343.315 115.83 343.233Z",
    fill: "#FA7B6A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.468 342.307L127.738 340.453M96.4842 391.572L102.046 378.063M103.82 372.766L115.29 343.366",
    stroke: "black",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4801 498.563L90.4588 399.093C91.5568 396.61 95.2356 397.19 95.5158 399.891L96.2209 406.69C96.2731 407.194 96.196 407.669 95.9724 408.123C92.589 414.99 64.3641 473.457 71.9448 497.86C72.5684 499.867 71.1896 502.283 69.0875 502.283H48.9025C46.988 502.283 45.7059 500.314 46.4801 498.563Z",
    fill: "#FA7B6A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4801 498.563L90.4588 399.093C91.5568 396.609 95.2356 397.19 95.5158 399.891L101.901 461.457C101.949 461.927 101.872 462.401 101.675 462.831L84.3583 500.735C83.9275 501.678 82.986 502.283 81.9492 502.283H48.9025C46.988 502.283 45.7059 500.314 46.4801 498.563Z",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228.275 335.034L200.954 325.065C199.226 324.435 197.398 325.714 197.398 327.553V429.027C197.398 429.947 197.875 430.802 198.66 431.283L218.639 443.56C219.121 443.856 219.496 444.299 219.708 444.824L245.455 508.575C245.86 509.577 246.832 510.232 247.911 510.232H302.198C304.11 510.232 305.392 508.267 304.622 506.517L229.791 336.456C229.501 335.795 228.953 335.282 228.275 335.034Z",
    fill: "#F6F6F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M219.577 444.501L245.723 509.238C245.966 509.838 246.549 510.232 247.197 510.232H282.084C283.881 510.232 285.262 504.14 282.084 502.816C253.684 483.451 206.138 416.559 206.138 339.394C206.138 305.258 198.232 418.47 197.458 429.629C197.417 430.219 197.713 430.701 198.217 431.011L218.936 443.742C219.225 443.92 219.45 444.185 219.577 444.501Z",
    fill: "#FA7B6A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M217.792 342.574L208.522 340.72M239.776 391.839L234.214 378.331M232.44 373.034L220.971 343.634",
    stroke: "black",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M288.72 498.566L244.742 399.096C243.644 396.612 239.965 397.193 239.685 399.894L233.3 461.46C233.251 461.93 233.329 462.404 233.525 462.834L250.842 500.738C251.273 501.681 252.215 502.285 253.251 502.285H286.298C288.213 502.285 289.495 500.317 288.72 498.566Z",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M228.275 335.034L200.954 325.065C199.226 324.435 197.398 325.714 197.398 327.553V429.027C197.398 429.947 197.875 430.802 198.66 431.283L218.639 443.56C219.121 443.856 219.496 444.299 219.708 444.824L245.455 508.575C245.86 509.577 246.832 510.232 247.911 510.232H302.198C304.11 510.232 305.392 508.267 304.622 506.517L229.791 336.456C229.501 335.795 228.953 335.282 228.275 335.034Z",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M138.587 461.757C140.657 456.486 145.743 453.021 151.405 453.021H186.947C192.793 453.021 198.002 456.711 199.94 462.226V462.226C203.09 471.184 196.442 480.566 186.947 480.566H151.405C141.698 480.566 135.036 470.792 138.587 461.757V461.757Z",
    fill: "#F6F6F1",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M196.368 464.193L195.89 461.71C194.92 456.666 190.507 453.021 185.371 453.021C179.455 453.021 174.659 457.816 174.659 463.732V480.566H182.842C191.492 480.566 198.001 472.687 196.368 464.193Z",
    fill: "#FA7B6A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M130.122 482.421C130.122 479.934 132.138 477.918 134.625 477.918H202.96C205.446 477.918 207.462 479.934 207.462 482.421C207.462 484.907 205.446 486.923 202.96 486.923H134.625C132.138 486.923 130.122 484.907 130.122 482.421Z",
    fill: "#F6F6F1",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M198.722 486.923C201.37 486.923 201.9 479.772 198.722 477.918H168.527V486.923H198.722Z",
    fill: "#FA7B6A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.122 482.421C130.122 479.934 132.138 477.918 134.625 477.918H202.96C205.446 477.918 207.462 479.934 207.462 482.421C207.462 484.907 205.446 486.923 202.96 486.923H134.625C132.138 486.923 130.122 484.907 130.122 482.421Z",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M150.163 453.231H188.46C197.305 453.231 205.868 446.061 205.868 437.216L204.476 148.247V108.557C204.476 100.775 198.925 94.2895 191.567 92.8433C191.132 86.2918 190.471 70.1723 187.651 55.2896C184.648 39.4438 179.197 25.0001 168.964 25.0001C158.736 25.0001 153.268 39.4389 150.301 55.2896C147.512 70.195 146.706 92.9477 146.694 92.919C139.517 94.5041 134.148 100.904 134.148 108.557V148.247L131.711 437.216C131.711 446.061 141.318 453.231 150.163 453.231Z",
    fill: "#F6F6F1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M188.46 453.233C197.305 453.233 205.868 446.062 205.868 437.217L205.536 368.266C192.129 374.199 175.8 314.234 169.312 283.509V453.233H188.46Z",
    fill: "#FA7B6A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M168.963 25.0002C158.736 25.0002 153.267 39.4389 150.301 55.2897C150.301 55.2897 161.472 50.7637 168.976 50.7637C176.48 50.7637 187.651 55.2897 187.651 55.2897C184.648 39.4438 179.197 25.0002 168.963 25.0002Z",
    fill: "#F6DE05"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M191.566 92.8433C198.925 94.2895 204.475 100.775 204.475 108.557V148.247L204.771 209.611C199.696 99.1622 178.592 96.5136 175.149 91.3546C175.183 91.2357 175.217 91.1064 175.252 90.9669C177.308 82.5539 178.435 37.2458 168.963 25.0002C179.197 25.0002 184.648 39.4438 187.651 55.2897C190.471 70.1723 191.132 86.2919 191.566 92.8433Z",
    fill: "#FA7B6A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M188.146 241.797C181.373 238.63 176.75 233.973 173.628 227.13C172.269 224.174 171.595 221.531 169.057 221.531C166.518 221.531 165.845 224.174 164.485 227.143C161.364 233.973 156.741 238.644 149.967 241.81C147.027 243.183 144.424 244.165 144.424 246.428C144.424 248.691 147.027 249.673 149.967 251.046C156.741 254.213 161.364 258.87 164.485 265.713C165.845 268.683 166.518 271.325 169.057 271.325C171.595 271.325 172.269 268.683 173.628 265.713C176.75 258.883 181.373 254.213 188.146 251.046C191.086 249.673 193.689 248.691 193.689 246.428C193.689 244.152 191.086 243.17 188.146 241.797Z",
    fill: "#FA7B6A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M168.792 90.9511V107.902M168.792 317.145V302.048M168.792 210.14V195.912M168.792 284.037V295.691M168.792 147.102V154.254",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M191.567 92.8433C198.925 94.2895 204.476 100.775 204.476 108.557V148.247L205.684 398.919M191.567 92.8433C191.16 92.7633 180.243 90.7508 168.964 90.8015C157.795 90.8516 146.682 92.8904 146.694 92.919M191.567 92.8433C191.132 86.2918 190.471 70.1723 187.651 55.2896M146.694 92.919C139.517 94.5041 134.148 100.904 134.148 108.557V148.247L132.04 398.223M146.694 92.919C146.706 92.9477 147.512 70.195 150.301 55.2896M150.301 55.2896C153.268 39.4389 158.736 25.0001 168.964 25.0001C179.197 25.0001 184.648 39.4438 187.651 55.2896M150.301 55.2896C150.301 55.2896 161.472 50.7636 168.976 50.7636C176.48 50.7636 187.651 55.2896 187.651 55.2896M131.981 405.186L131.711 437.216C131.711 446.061 141.318 453.231 150.163 453.231H188.46C197.305 453.231 205.868 446.061 205.868 437.216L205.714 405.186M131.981 405.186C156.824 401.713 180.871 401.713 205.714 405.186M131.981 405.186L132.04 398.223M205.714 405.186L205.684 398.919M132.04 398.223C157 394.192 180.81 394.401 205.684 398.919",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 172.07,
    cy: 177.132,
    r: 15.9918,
    fill: "#FA7B6A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 168.892,
    cy: 173.951,
    r: 15.9918,
    fill: "#F6F6F1",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 168.892,
    cy: 173.954,
    r: 11.1458,
    fill: "#1C1C1C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.6,
    cy: 129.457,
    r: 15.9918,
    fill: "#FA7B6A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 168.892,
    cy: 126.807,
    r: 15.9918,
    fill: "#F6F6F1",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 168.892,
    cy: 126.81,
    r: 11.1458,
    fill: "#1C1C1C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M124.825 456.351C124.825 453.291 125.333 450.159 127.16 447.705C127.58 447.142 128.025 446.61 128.494 446.113C131.056 443.399 134.932 442.655 138.658 442.422C158.419 441.187 178.045 441.15 197.799 442.32C202.488 442.598 207.178 444.326 210.388 447.756C210.48 447.854 210.572 447.954 210.663 448.055C212.641 450.242 213.257 453.246 213.257 456.195V456.195C213.257 459.355 212.538 462.548 210.517 464.976C210.237 465.313 209.955 465.635 209.673 465.943C206.968 468.891 202.96 470.085 198.967 470.331C178.826 471.571 158.824 471.562 138.682 470.304C134.94 470.07 131.051 469.311 128.482 466.582C128.025 466.097 127.592 465.58 127.182 465.033C125.338 462.572 124.825 459.425 124.825 456.351V456.351Z",
    fill: "#F6F6F1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M200.576 441.894H175.943V470.5H200.576C204.814 467.851 205.608 446.132 200.576 441.894Z",
    fill: "#FA7B6A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M124.825 456.363C124.825 449.067 130.39 442.954 137.67 442.485C158.637 441.132 179.448 441.128 200.415 442.482C207.694 442.953 213.257 449.066 213.257 456.36V456.36C213.257 463.656 207.693 469.77 200.413 470.24C179.446 471.593 158.635 471.593 137.668 470.239C130.388 469.77 124.825 463.657 124.825 456.363V456.363Z",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M124.824 457.058H132.31M212.908 457.058H209.948M154.069 457.058H151.981M190.278 457.058H202.289M139.795 457.058H145.634",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M165.614 336.071H172.5L177.533 514.996H160.052L165.614 336.071Z",
    fill: "#F6F6F1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M177.533 514.998L172.5 336.073H169.057L168.792 514.998H177.533Z",
    fill: "#FA7B6A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M172.5 336.073L170.911 325.885H168.924L169.057 336.073H172.5Z",
    fill: "#FA7B6A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M165.614 336.073H172.501M165.614 336.073L160.052 514.999H177.533L172.501 336.073M165.614 336.073L166.938 325.885H170.911L172.501 336.073",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRocketship);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rocketship.f19dcd11d34dcf643fae82bcac1c0aae.svg";